import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { Brand } from "../models/brand";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Page } from "../data-types/page";

@Injectable({
  providedIn: "root",
})
export class BrandService {
  private marketUrl = environment.apiUrl + "/market";
  private brandCache: Brand[] = [];

  constructor(private http: HttpClient) {}

  getBrands(page: number = 0, size: number = 10, includingInactives: boolean = false): Observable<Page<Brand>> {
    const params = new HttpParams()
      .set("page", page.toString())
      .set("size", size.toString())
      .set("includingInactives", includingInactives.toString());

    return this.http.get<Page<Brand>>(this.marketUrl + "/all-brands", {
      params,
    });
  }

  getBrandById(brandId: number): Observable<Brand | undefined> {
    return this.http.get<Brand>(this.marketUrl + "/brand/" + brandId);
  }

  updateBrand(brandId: number, brand: Brand, image?: File): Observable<Brand> {
    const formData = new FormData();
    formData.append("brand", new Blob([JSON.stringify(brand)], { type: "application/json" }));
    if (image) {
      formData.append("image", image, image.name);
    }

    return this.http.put<Brand>(this.marketUrl + "/brand/" + brandId, formData);
  }

  createBrand(brand: Brand, image?: File): Observable<Brand> {
    const formData = new FormData();
    formData.append("brand", new Blob([JSON.stringify(brand)], { type: "application/json" }));
    if (image) {
      formData.append("image", image, image.name);
    }

    return this.http.post<Brand>(this.marketUrl + "/brand", formData);
  }

  deleteBrand(brand: Brand): Observable<void> {
    const formData = new FormData();
    formData.append("brandId", brand.id.toString());
    formData.append("name", brand.name);
    formData.append("isActive", "N");
    return this.http.post<void>(this.marketUrl + "/brand/" + brand.id, formData);
  }
}
